import React, { createContext, useState, useEffect } from "react";

export const DataContext = createContext();

function prepareData(data) {
  return data.map((record) => {
    return { id: record.id, ...record.fields };
  });
}

export const DataProvider = ({ children }) => {
  const [deals, setDeals] = useState([]);
  const [mainData, setMainData] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const simulatorSupportReq = await fetch(
          "https://vennre-integration-c9fp.onrender.com/at/api/getTable",
          {
            method: "GET",
            headers: {
              authorization:
                "patyxj894yfksau9OqUo81O4X2kyI6SeJPizmctUcyc3OCvGClY5UqQSyrN3809a78aff3f85f8effdda1b351bd36JsA93llvB1jb1hYgIBlD9q6QuCcmDdXpl81f54ed6dcf",
              tablename: "Simulator Support",
            },
          }
        );
        const simulatorSupportRaw = await simulatorSupportReq.json();
        const simulatorSupport = prepareData(simulatorSupportRaw).filter(
          (record) => record["VSimulator Trigger"]
        );
        setDeals(simulatorSupport);

        if (simulatorSupport.length) {
          const simulatorCoreReq = await fetch(
            "https://vennre-integration-c9fp.onrender.com/at/api/getTable",
            {
              method: "GET",
              headers: {
                authorization:
                  "patyxj894yfksau9OqUo81O4X2kyI6SeJPizmctUcyc3OCvGClY5UqQSyrN3809a78aff3f85f8effdda1b351bd36JsA93llvB1jb1hYgIBlD9q6QuCcmDdXpl81f54ed6dcf",
                tablename: "Simulator Core",
              },
            }
          );
          const simulatorCoreRaw = await simulatorCoreReq.json();
          const simulatorCore = prepareData(simulatorCoreRaw).filter(
            (record) => record.Scenario === "Base"
          );

          const filteredSimulatorCore = simulatorCore.filter((record) => {
            const supportRecord = simulatorSupport.find(
              (deal) => deal.id === record["Imported table 2"].join("")
            );
            return supportRecord && supportRecord["VSimulator Trigger"];
          });

          setMainData(
            filteredSimulatorCore.map((record) => {
              const companyName = simulatorSupport.find((deal) => {
                return deal.id === record["Imported table 2"].join("");
              })?.Deals;
              return {
                ...record,
                Deals: companyName,
                Currency: record.Currency,
              };
            })
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    loadData();
  }, []);

  const value = { deals, mainData };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
